import React, { JSX } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

interface ProtectedRouteProps {
  children: JSX.Element;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user } = useAuth();

  // If no token, redirect to login
  if (!user?.token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
